import { FunctionComponent } from 'react';

import Image from 'components/layout/Image';
import Video from 'components/layout/Video';
import DescriptionBlock from 'components/modules/public/layout/sections/blocks/Description';
import TwoColBlock from 'components/modules/public/layout/sections/blocks/TwoCol';

import StyledComponent from './styles';
import { Col, Props } from './types';

const PublicLayoutSectionsDescriptionTwoCol: FunctionComponent<Props> = ({ list, direction }) => {
    if(!Array.isArray(list) || !list.length) return null;
    const getCol = (col: Col) => {
        if(col.copy) {
            return (
                <DescriptionBlock {...col.copy} />
            );
        }

        if(col.image) {
            return (
                <Image {...col.image} />
            );
        }

        if(col.video) {
            return (
                <Video {...col.video} />
            );
        }

        return null;
    };

    return (
        <StyledComponent className="public-layout-sections-description-two-col">
            <div className="list">
                {list.map((listElem) => (
                    <TwoColBlock
                        key={listElem.key}
                        direction={listElem.direction || direction}
                        leftCol={getCol(listElem.leftCol)}
                        rightCol={getCol(listElem.rightCol)}
                    />
                ))}
            </div>
        </StyledComponent>
    );
};

export default PublicLayoutSectionsDescriptionTwoCol;
